import { useNavigate } from 'react-router'
import { Button, Icon, Typography } from 'shared/ui'
import { LINK_10DLC_LIMITS_EXCEEDED } from 'shared/constants/links.ts'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout.tsx'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath.ts'
import { LVSPackageCard } from 'pages/settings/pages/compliance/pages/localNumbers/pages/Package/ui/LVSPackageCard.tsx'
import { StandardPackageCard } from 'pages/settings/pages/compliance/pages/localNumbers/pages/Package/ui/StandardPackageCard.tsx'
import styles from './styles.module.scss'

export const Package = () => {
  const navigate = useNavigate()
  return (
    <StepsCommonLayout
      progressTitle={'Package'}
      title={'Upgrade 10DLC package'}
      totalSteps={2}
      settingsStep={1}
      closeSetting={() => navigate('/' + CompliancePath.compliance.localNumbers.root)}
      content={
        <>
          <div className={styles.desc}>
            <Typography ariaLabel={'desc'} variant={'body-md-regular'} color={'tertiary'}>
              Select the 10DLC registration package that fits your business. Salesmsg passes through
              these fees at cost with no markup.{' '}
            </Typography>

            <Typography ariaLabel={'learnMore'} variant={'body-md-medium'} linkLight>
              <a href={LINK_10DLC_LIMITS_EXCEEDED} target='_blank' rel='noreferrer'>
                Learn more
              </a>
            </Typography>
          </div>
          <div className={styles.content}>
            <LVSPackageCard titleLabel={'Current'} titleLabelColor={'gray'} />
            <div className={styles.arrowWrap}>
              <div className={styles.arrow}>
                <Icon icon={'arrowDown'} tertiary />
              </div>
            </div>

            <StandardPackageCard price={'$61'} checked />
          </div>
          <div className={styles.actions}>
            <Button
              text={'Next'}
              onClick={() => navigate(CompliancePath.compliance.upgrade10DLCPackage.summary)}
              size={'large'}
              fullWidth
            />
          </div>
        </>
      }
    />
  )
}
